import { memo } from "react";

import { tw, type TTailwindString } from "classnames";

const styles = {
  base: tw(
    "mb-3",
    "flex",
    "h-7",
    "items-center",
    "gap-2",
    "md:mb-4",
    "mg:mb-3"
  ),
  stars: tw(
    "h-3.5",
    "w-full",
    "max-w-[80px]" as TTailwindString,
    "rounded-full",
    "bg-placeholder"
  ),
  text: tw(
    "h-2",
    "w-full",
    "max-w-[120px]" as TTailwindString,
    "rounded-full",
    "bg-placeholder"
  ),
};

const ProductHeroRatingPlaceholderBase = () => (
  <div className={styles.base} data-placeholder-region="component">
    <div className={styles.stars}></div>
    <div className={styles.text}></div>
  </div>
);

export const ProductHeroRatingPlaceholder = memo(
  ProductHeroRatingPlaceholderBase
);
